var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddOtherPlatforms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4974 46.3346C13.9911 46.3346 4.66406 37.0076 4.66406 25.5013C4.66406 13.9951 13.9911 4.66797 25.4974 4.66797C37.0036 4.66797 46.3307 13.9951 46.3307 25.5013C46.3307 37.0076 37.0036 46.3346 25.4974 46.3346ZM23.4141 23.418H15.0807V27.5846H23.4141V35.918H27.5807V27.5846H35.9141V23.418H27.5807V15.0846H23.4141V23.418Z",
    fill: "#121B2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddOtherPlatforms);
export default __webpack_public_path__ + "static/media/add_other_platforms.c35deb1a605a237feca1e7232e842f15.svg";
export { ForwardRef as ReactComponent };